// tslint:disable:no-empty-interface
import {
	IComment,
	ITaskInfo,
	ITaskMainRoute,
	ITaskMainRouteStep,
	ITaskMainRouteTerminalState,
	ITaskStep,
	IUserShort,
	ICategoryShort,
	ISubCategoryShort,
	ICategoryStep,
	INewsResponse,
	ITaskTemplate,
	IUser,
} from '@valhalla/data/entities';
import { Observable } from 'rxjs';
import { IUserShortInfo } from '..';
import { ISubcatInfo } from '../../entities/subcat';
import { FeedTasksType } from '../feeds';

export abstract class TaskDataHttpService {
	abstract feeds(criteria: ITaskFeedsCriteria): Observable<ITaskFeedsResult>;
	abstract getInfo(criteria: ITaskInfoCriteria): Observable<ITaskInfo>;
	abstract getInfoParts(criteria: ITaskInfoCriteria): Observable<ITaskInfo>;
	abstract getNews(criteria: ITaskNewsCriteria): Observable<INewsResponse>;
	abstract getGanttCategoryData(criteria: IGanttCategoryCriteria): Observable<any>;
	abstract getGanttSubcategoryData(criteria: IGanttSubcategoryCriteria): Observable<any>;
	abstract setLike(criteria: ITaskNewsCriteria): Observable<any>;
	abstract findNewsTemplate(taskTemplates: ITaskTemplate[]): ITaskTemplate;
	abstract removeTask(criteria: ITaskInfoCriteria): Observable<any>;
	abstract addToFavorites(criteria: ITaskAddToFavoritesCriteria): Observable<any>;
	abstract removeFromFavorites(criteria: ITaskRemoveFromFavoritesCriteria): Observable<any>;
	abstract updateFavorites(criteria: ITaskUpdateFavoritesCriteria): Observable<any>;

	abstract unsubscribeFromTask(criteria: any): Observable<any>;
	abstract unsubscribeFromTask2(taskId: number): Observable<any>;

	abstract getRoute(criteria: ITaskRouteCriteria): Observable<ITaskMainRouteResult>;
	abstract getSteps(criteria: ITaskStepsCriteria): Observable<ITaskStep[]>;
	abstract getCategorySteps(criteria: ICategoryStepsCriteria): Observable<ICategoryStep>;
	abstract getGridBlockData(criteria: ITaskGridBlockDataCriteria): Observable<ITaskGridBlockDataResult>;
	abstract getCategoryShortInfo(criteria: ICategoryInfoCriteria): Observable<ICategoryShort>;
	abstract getSubCategoryShortInfo(criteria: ISubCategoryInfoCriteria): Observable<ISubCategoryShort>;
	abstract getSubCategoryInfo(criteria: ISubCategoryInfoCriteria): Observable<ISubcatInfo>;
	abstract getSubcategoryTemplate(criteria: INtfTaskTemplateCriteria): Observable<INtfTaskTemplate>;
	abstract getCategoryTree(criteria: ICategoryTreeCriteria): Observable<ICategoryTreeResult>;

	abstract executeStep(criteria: IExecuteTaskStepCriteria): Observable<IExecuteTaskStepResult>;
	abstract executeStepWithComment(
		taskId: number,
		criteria: IExecuteTaskStepWithCommentCriteria
	): Observable<IExecuteTaskStepWithCommentResult>;

	abstract isExists(criteria: ITaskExistsCriteria): Observable<ITaskExistsResult>;
	abstract pin(criteria: ITaskPinCriteria): Observable<ITaskPinResult>;
	abstract unpin(criteria: ITaskUnPinCriteria): Observable<ITaskPinResult>;

	abstract executeAction(criteria: IExecuteTaskActionCriteria): Observable<IExecuteTaskActionResult>;
	abstract executeSignatureResolution(
		criteria: IExecuteSignatureResolutionCriteria
	): Observable<IExecuteSignatureResolutionResult>;
	abstract subscribeUsers(criteria: ITaskSubscribeUserCriteria): Observable<any>;
	abstract unsubscribeUsers(criteria: ITaskSubscribeUserCriteria): Observable<any>;

	abstract getTasks(criteria: ITasksCriteria): Observable<any>;
	abstract getTaskRecurrence(criteria: ITaskRecurrenceCriteria): Observable<ITaskRecurrence>;
	abstract saveTaskRecurrence(data: ITaskRecurrence): Observable<any>;
	abstract disableTaskRecurrence(criteria: ITaskDisableRecurrenceCriteria): Observable<any>;
	abstract search(criteria: ITaskSearchCriteria): Observable<ITaskFeedsResult>;

	abstract getStatuses(taskId: number): Observable<IStatusesResponse>;
	abstract changeTaskStatus(criteria: IChangeTaskStatusCriteria): Observable<any>;

	abstract lockDueDate(taskId: number): Observable<any>;
	abstract unlockDueDate(taskId: number): Observable<any>;

	abstract changeOwner(criteria: ITaskChangeOwnerCriteria): Observable<any>;
	abstract assignExecutor(taskId: number, body: { add: number[]; remove: number[] }): Observable<void>;
	abstract assignResponsible(taskId: number, performerId: number): Observable<void>;

	abstract changePriority(criteria: ITaskChangePriorityCriteria): Observable<any>;
	abstract changeDueDate(criteria: ITaskChangeDueDateCriteria): Observable<any>;
	abstract changeDueDate2(criteria: ITaskChangeDueDate2Criteria): Observable<any>;
	abstract changeSignatureReason(criteria: ITaskChangeSignatureReasonCriteria): Observable<any>;
	abstract updateTaskStartTime(criteria: ITaskUpdateStartTimeCriteria): Observable<any>;

	abstract getFiles(criteria: ITaskFilesCriteria): Observable<any>;
	abstract clearDeletedFiles(criteria: ITaskClearDeletedFilesCriteria): Observable<any>;
	abstract pinFile(criteria: ITaskPinFileCriteria): Observable<any>;
	abstract unpinFile(criteria: ITaskUnpinFileCriteria): Observable<any>;
	abstract deleteFile(criteria: ITaskDeleteFileCriteria): Observable<any>;

	abstract deleteTask(criteria: number[]): Observable<any>;
	abstract getUnreadNews(): Observable<any>;
	abstract getUnreadNewsContent(criteria: number): Observable<any>;
	abstract closeUnreadNewsContent(criteria: number): Observable<any>;

	abstract createTask(criteria: ICreateTask): Observable<ICreateTaskResponse>;
	abstract createNewDoc(criteria: ICreateNewDocCriteria): Observable<any>;
	abstract encryptTask(taskId: number): Observable<any>;
	abstract setConfidentialTask(criteria: ITaskSetConfidential): Observable<any>;
	abstract getReports(taskId: number): Observable<IGetTaskReportsResult>;
	abstract checkExistAndAccess(taskId: number): Observable<ICheckExistAndAccess>;

	abstract getEmails(criteria: ITaskEmailsCriteria): Observable<ITaskEmailsResponse[]>;

	abstract updateTaskAvatar(criteria: IUpdateTaskAvatarCriteria): Observable<any>;
	abstract removeTaskAvatar(criteria: Pick<IUpdateTaskAvatarCriteria, 'taskId'>): Observable<any>;
	abstract getTaskAvatar(taskId: number): Observable<null | string>;
	abstract getTaskAvatarUrl(taskId: number): string;

	abstract getSignatureHistory(taskId: number, request: any): Observable<IRequestedSignature[]>;
	abstract getTaskSignatureSnapshot(taskSignatureId: number): Observable<ITaskFullSnapshot>;
	abstract getSignatures(): Observable<ISignaturesRes>;
	abstract getExistanceFileByName(criteria: {
		taskId: number;
		fileNames: string[];
	}): Observable<IFileExistanceDto[] | Record<string, boolean>>;
}

export interface ISignaturesRes {
	tasksForAccept: {
		activeTaskIds: number[];
		myTasksForAccept: IMyTasksForAccept[];
	};
}

export interface IMyTasksForAccept {
	EdsFiles: any[];
	EdsType: string;
	IsAsyncAvailable: boolean;
	IsQueued: boolean;
	PcIsServerSign: boolean;
	canBeEscalated: boolean;
	description: string;
	extParams: any[];
	guid: string;
	mobileTemplate: any;
	owner: IUserShort;
	reason: string;
	requestReasonOnAccept: boolean;
	requestor: ISignatureRequestor;
	responsiblePerformer: IUserShort;
	signatureAcceptants: ISignaturesAcceptans[];
	signatureResolutions: ISignatureResolutions[];
	subcat: any;
	taskId: number;
	taskSignatureId: number;
	taskSignatureInitializeDate: string;
	taskSignatureOrderedTime: string;
	taskText: string;
}

export interface ISignaturesAcceptans {
	Absences: any;
	Id: number;
	IsLastOnlineFromMobileApp: boolean;
	IsOnline: boolean;
	LastOnlineTime: string;
	LastPersonalInfoUpdateTime: string;
	Name: string;
	UserState: any;
}

export interface ISignatureRequestor {
	Absences: any[];
	BirthDate: string;
	BirthDaySoon: boolean;
	DisplayName: string;
	Gender: number;
	HasAvatar: boolean;
	IsEmployee: boolean;
	IsLastOnlineFromMobileApp: boolean;
	LastOnlineTime: string;
	LastPersonalInfoUpdateTime: string;
	UserId: number;
	UserName: string;
}

export interface ISignatureResolutions {
	DialogHeader: string;
	Name: string;
	NeedConfirm: boolean;
	ReasonRequired: boolean;
	ResolutionTypeId: number;
	SignatureAction: ResolutionAction;
}

export enum ResolutionAction {
	accept = 'Accept',
	reject = 'Reject',
	delete = 'Delete',
	delegate = 'Delegate',
	journal = 'openJournal',
	escalate = 'Escalate',
}

export interface IUpdateTaskAvatarCriteria {
	taskId: number;
	fileName: string;
	base64File: string;
}

export interface ITaskClearDeletedFilesCriteria {
	taskId: number;
}
export interface ITaskClearDeletedFilesCriteria {
	taskId: number;
}

export interface ITaskEmailsResponse {
	emailId: number;
	subject: string;
	from: string;
	to: string;
	dateSent: string;
	cc: string;
	bcc: string;
}

export interface ITaskEmailsCriteria {
	taskId: number;
	limit: number;
	offset: number;
}

export interface IExecuteTaskStepWithCommentResult {
	ok: boolean;
	errorMessage: string;
	newStateId: number;
	redirectResult: {
		openLinkTarget: string;
	};
	requiredExtParams: number[];
}

export interface IExecuteTaskStepWithCommentReason {
	taskStepId: number;
	signatureId: number;
	reason: string;
}

export interface IExecuteTaskStepWithCommentCriteria {
	stepId?: number;
	comment?: string;
	reasons?: IExecuteTaskStepWithCommentReason[];
	forUserId?: number;
	userConfirmedTSTAction?: boolean;
	location?: {
		id: number;
		userId: number;
		country: string;
		city: string;
		street: string;
		streetNumber: string;
		created: string;
		latitude: number;
		longitude: number;
		accuracy: number;
		state: string;
		message: string;
	};
}

export interface ICheckExistAndAccess {
	isTaskExists: boolean;
	isUserHasAccess: boolean;
	taskShortInfo: ITaskShortInfo;
}

export interface ITaskShortInfo {
	subcatId: number;
	ownerId: number;
	isEncrypted: boolean;
	isClosed: boolean;
	isWaitingSign: boolean;
	isConfidential: boolean;
	description?: any;
	priorityId: string;
	stateId: number;
	owner: IUserShort;
	id: number;
}
export interface ITaskSetConfidential {
	taskId: number;
	isConfidential: boolean;
}

export interface ITaskChangeDueDate2Criteria {
	newDate: string;
	reason: string;
	аddToQuickReply: boolean;
	taskId: number;
}
export interface ICreateNewDocCriteria {
	taskId: number;
	docType: string;
}

export interface IGetTaskReportsResult {
	reports: {
		id: number;
		name: string;
	}[];
}

export interface ITaskDeleteFileCriteria {
	parentFolderType: number;
	parentFolderId: number;
	fileId: number;
}

export interface ITaskUnpinFileCriteria {
	taskId: number;
	fileId: number;
}
export interface ITaskPinFileCriteria {
	taskId: number;
	fileId: number;
}

export interface ITaskFilesCriteria {
	taskId: number;
	extFilterList?: string[];
	limit?: number;
	offset?: number;
	onlyPinned?: boolean;
	noPinned?: boolean;
	extExcludeList: string[];
	pinnedFirst?: boolean;
	showDeleted?: boolean;
}

export interface ITaskUpdateStartTimeCriteria {
	newStartTime: string | Date;
	reason: string;
	taskId: number;
}
export interface ILocation {
	Accuracy?: number;
	Latitude?: number;
	Longitude?: number;
}

export interface ITaskChangeSignatureReasonCriteria {
	taskSignatureId: number;
	reason: string;
	location: ILocation;
}

export interface ITaskChangeDueDateCriteria {
	reason: string;
	taskId: number;
	silentMode: boolean;
	dueDate: string | Date;
	id?: number;
}
export interface ITaskChangePriorityCriteria {
	taskId: number;
	priority: 'Low' | 'Normal' | 'High';
}
export interface ITaskChangeOwnerCriteria {
	taskId: number;
	newOwnerId: number;
}

export interface IChangeTaskStatusCriteria {
	taskId: number;
	newStateId: number;
}
export interface IStatusesResponse {
	states: IStatus[];
}

export interface IStatus {
	id: number;
	name: string;
}
export interface ITaskSearchCriteria {
	filter: string | string[];
	skip: number;
	take: number;
	feedTypes?: FeedTasksType[];
}

export interface IGanttCategoryCriteria {
	categoryId: number;
}

export interface IGanttSubcategoryCriteria {
	subcategoryId: number;
}
export interface ITasksCriteria {
	subcatId: number;
	limit: number;
	offset: number;
	blockId: any;
	showClosed?: boolean;
	showRejected?: boolean;
	isCropHtml?: boolean;
	search?: string;
}

export interface ITaskSubscribeUserCriteria {
	taskId: number;
	userIds: number[];
}

export interface IExecuteSignatureResolutionCriteria {
	signatureId: number;
	signatureAction: string;
	params: {
		reason?: string;
		resolutionTypeId?: number;
		options?: Partial<{
			taskStepIdAfterRejectDecision: number;
			acceptorsToDelegate: number[];
			replaceAcceptorsOnDelegate: boolean;
		}>;
	};
}

export interface IExecuteSignatureResolutionResult {
	id: number;
	requestedTaskSignatures: number[];
}

export interface ITaskAddToFavoritesCriteria {
	taskId: number;
	color?: string;
	favsFolderId?: number;
}

export interface ITaskUpdateFavoritesCriteria {
	taskId: number;
	color?: string;
	favsFolderIds?: number[];
}

export interface ITaskRecurrenceCriteria {
	taskId: number;
}

export interface ITaskDisableRecurrenceCriteria {
	taskId: number;
}
export interface ITaskRecurrence {
	taskId: number;
	ended?: boolean;
	occurrenceCount?: number;
	lastRun?: string;
	copySubsсribers?: true;
	recurrenceDto: ITaskRecurrenceDto;
	orderedTimeTotalMinutes?: number;
	orderedTimeDays: number;
	orderedTimeHours: number;
	orderedTimeMinutes: number;
	canChangeRepeatExecutionTime?: boolean;
	orderedTimeMode?: string;
	orderedTimeDeadline?: string;
	id?: number;
}

export interface ITaskRecurrenceDto {
	start: string;
	endByDate?: string;
	type: number;
	weekDays: number;
	periodicity: number;
	minutesInterval?: number;
	weekOfMonth: number;
	dayNumber: number;
	month: number;
	range?: number;
	occurrenceCount?: number;
	onlyWorkTime?: boolean;
	parentFilesBehavior: string;
	id?: number;
}
export interface ITaskNewsCriteria {
	taskId: number;
}

export interface ITaskRemoveFromFavoritesCriteria {
	taskId: number;
}

export interface ITaskUnPinCriteria {
	taskId: number;
}

export interface ITaskPinCriteria {
	taskId: number;
}

export interface ITaskPinResult {}

export interface ITaskExistsCriteria {
	taskId: number;
}

export interface ITaskExistsResult {
	isExists: boolean;
}

export enum ExecuteTaskActionRedirectType {
	link = 'Link',
}

export interface IExecuteTaskActionSignatureCriteria {
	id: number;
	description: string;
	reason: string;
}

export interface IExecuteTaskActionResult {
	message?: string;
	redirectResult?: {
		redirectType: ExecuteTaskActionRedirectType;
		openLinkTarget: 1 | 2 | 3;
		action: string;
		link: string;
	};
	success: boolean;
}

export interface IExecuteTaskActionCriteria {
	taskId: number;
	actionId: number | string;
	comment?: string;
	signatures?: Array<IExecuteTaskActionSignatureCriteria>;
}

export interface IExecuteTaskStepResult {
	newStateId: number;
	requestedSignatures?: number[];
	redirect?: {
		redirectType: string;
	};
	errorMessage?: string;
}

export interface IExecuteTaskStepCriteria {
	taskId: number;
	stepId: number;
	comment?: string;
}

export interface ICategoryTreeCriteria {
	categoryId?: number;
	subCategoryId?: number;
	taskId?: number;
}

export interface ICategoryTreeResult {
	records: Record<number, ISubCategoryShort | ICategoryShort>;
}
export interface ICategoryInfoCriteria {
	categoryId: number;
}
export interface ISubCategoryInfoCriteria {
	subCategoryId: number;
}

export interface ITaskGridBlockDataCriteria {
	blockId: number;
	taskId: number;
}

export interface ITaskGridBlockDataResult {
	tasks: Array<Partial<ITaskInfo>>;
	tabs: any[];
	categories: any[];
	templates?: any[];
}

export interface ITaskInfoCriteria {
	taskId: number;
	parts?: TaskInfoPart[];
}
export enum TaskInfoPart {
	comments = 'comments',
	extParams = 'ExtParams',
	subscribers = 'subscribers',
	performers = 'performers',
	toolbar = 'toolbar',
	actions = 'Actions',
	requestedSignatures = 'RequestedSignatures',
	optionalSignatures = 'OptionalSignatures',
}

export interface ITaskRouteCriteria extends ITaskInfoCriteria {}
export interface ITaskStepsCriteria extends ITaskInfoCriteria {}
export interface ICategoryStepsCriteria {
	subcatId: number;
}
export interface ITaskChangeStateCriteria extends ITaskInfoCriteria {
	stateId: number;
	comment?: string;
}

export interface ITaskFeedsResult {
	categories: [];
	tabs: Array<{
		hasMoreTasks: boolean;
		taskIds: number[];
		type: number;
	}>;
	tasks: Array<Partial<ITaskFeedDto>>;
	templates: [];
}

export interface ITaskFeedsCriteria {
	limit: number;
	offset: number;
	feedTypes: Array<TaskFeedType | FeedTasksType>;
	subcatId: number;
	extendedSearch: boolean;
	catId: number;
	summaryId: number;
	filters: Array<ITaskFeedsFilter>;
	sorters: Array<ITaskFeedsSorter>;
	showClosed: boolean;
	showLastComment: boolean;
	include?: TaskFeedInclude[];
}

export interface ITaskFeedsFilter {
	filterType: TaskFeedsFilter;
	filterOperation: TaskFeedsFilterOperation;
	filterValues: any[];
	extParamValue?: any;
	extParamId?: number;
	sortType?: SortType;
}

export interface ITaskFeedsSorter {
	sorterType: TaskFeedsSorter;
	sortDir: SortType;
}

export enum TaskFeedsSorter {
	none = 'None',
	lastCommentDate = 'LastCommentDate',
}

export enum SortType {
	desc = 'desc',
	asc = 'asc',
}

export enum TaskFeedsFilter {
	none = 'None',
	dateTimeTaskFilter = 'DateTimeTaskFilter',
	search = 4,
}

export enum TaskFeedsFilterOperation {
	unknown = 'Unknown',
	searchOperation = 64,
}

export enum TaskFeedType {
	all = 'All',
	favorites = 'Favorites',
}

export enum TaskFeedInclude {
	subscribers = 'Subscribers',
}

export interface ITaskFeedDto {
	color: any;
	comments: Array<Partial<IComment>>;
	counters: [];
	createdDate: string;
	dueDateChangeCount: number;
	extParams: any;
	files: [];
	guid: string;
	isClosed: boolean;
	isOverdue: boolean;
	isRejected: boolean;
	isWaitingSign: boolean;
	isWorkFinished: boolean;
	lastCommentID: number;
	lastCommentText: string;
	linkedTaskId: number;
	maxCommentsDate: string;
	modifiedDate: string;
	notShowChangeDueDateCount: boolean;
	orderedTime: any;
	owner: Partial<IUserShort>;
	ownerID: number;
	priority: number;
	questionCount: number;
	responsiblePerformer: any;
	stateDescription: string;
	stateID: number;
	subcatID: number;
	taskID: number;
	taskStartDate: string;
	taskText: string;
	templateInfo: any;
	unreadCount: number;
}

export interface ITaskMainRouteResult {
	taskMainRoute: ITaskMainRoute;
	steps: ITaskMainRouteStep[];
	terminalStates: ITaskMainRouteTerminalState[];
}

export interface IFilesCount {
	type: IFilesCountType;
	count: number;
}

export enum IFilesCountType {
	overall = 'Overall',
	unknown = 'Unknown',
	images = 'Images',
	audio = 'Audio',
	video = 'Video',
	emails = 'Emails',
}

export interface INtfTaskTemplateCriteria {
	subcatId: number;
	parentTaskId?: number;
	taskId?: number;
}

export interface INtfTaskTemplateExtParam {
	id: number;
	type: string;
	name: string;
	value?: any;
	isRequired: boolean;
	isHidden: boolean;
	hideIfEmpty: boolean;
	canEdit: boolean;
	order: number;
	regularExpression: string;
	regularExpressionAlert: string;
}

export interface INtfTaskTemplateSettings {
	singleChoice: boolean;
	allowDeleteSelf: boolean;
	allowGroups?: boolean;
}

export interface INtfTaskTemplateMainParam {
	type: string;
	value: any;
	isRequired: boolean;
	canEdit: boolean;
	placeholder: string;
	settings: INtfTaskTemplateSettings;
	name: string;
}

export interface INtfTaskTemplate {
	isChat: boolean;
	subcatDescription: string;
	subcatMobileTemplate?: any;
	epSourceTaskId?: any;
	pinToChat: boolean;
	extParams: INtfTaskTemplateExtParam[];
	template?: any;
	mainParams: INtfTaskTemplateMainParam[];
}

export interface ICreateTaskExtParam {
	id: number;
	value: string;
}

export interface ICreateTaskOnSuccessParams {
	onSuccessJs: string;
	openInSecFrame: string;
	returnUrl: string;
	returnJs: string;
	refreshRadWindowParent: string;
}

export interface ICreateTaskRecurrenceDto {
	start: Date;
	endByDate: Date;
	type: number;
	weekDays: number;
	periodicity: number;
	minutesInterval: number;
	weekOfMonth: number;
	dayNumber: number;
	month: number;
	range: number;
	occurrenceCount: number;
	onlyWorkTime: boolean;
	parentFilesBehavior: string;
	id: number;
}

export interface ICreateTaskTaskRecurrence {
	taskId: number;
	ended: boolean;
	occurrenceCount: number;
	lastRun: Date;
	copySubsсribers: boolean;
	recurrenceDto: ICreateTaskRecurrenceDto;
	orderedTimeTotalMinutes: number;
	orderedTimeDays: number;
	orderedTimeHours: number;
	orderedTimeMinutes: number;
	canChangeRepeatExecutionTime: boolean;
	orderedTimeMode: string;
	orderedTimeDeadline: Date;
	id: number;
}

export interface ICreateTaskTaskReminder {
	taskId: number;
	comment: string;
	reminderDate: Date;
	sendSms: boolean;
	recipientIds: number[];
	userId: number;
	commentRecipients: string;
	copyInOutlook: boolean;
	id: number;
}

export interface ICreateTask {
	subcatId: number;
	text: string;
	owner: number;
	createFromParentOwner?: boolean;
	performers?: number[];
	separateTaskForEachPerformer?: boolean;
	subscribers?: number[];
	subscribeGroups?: number[];
	copySubscribers?: boolean;
	notifyUsers?: number[];
	orderedTime?: Date;
	lockOrderedTime?: boolean;
	taskStartTime?: Date;
	plannedStartTime?: Date;
	plannedEndTime?: Date;
	priority?: number;
	extParams?: ICreateTaskExtParam[];
	parentTaskId?: number;
	linkedTaskId?: number;
	linkedEmailId?: number;
	parentCommentId?: number;
	extParamSourceTaskId?: number;
	preuploadedFiles?: number[];
	filesIds?: number[];
	linkFiles?: number[];
	parentFiles?: string;
	parentEmails?: string;
	isConfidential?: boolean;
	isConsisImplement?: boolean;
	location?: string;
	guid?: string;
	userComment?: string;
	onSuccessParams?: ICreateTaskOnSuccessParams;
	taskRecurrence?: ICreateTaskTaskRecurrence;
	taskReminder?: ICreateTaskTaskReminder[];
	pinToChat?: boolean;
	sourceBlockId?: number;
}

export interface ICreateTaskResponse {
	customCallbackJs: string;
	message: string;
	newTaskIds: number[];
	redirectToSubcatId: number;
	redirectToTaskId: number;
}

export interface IRequestedSignature {
	id: number;
	finalAcceptorId: number | null;
	finalAcceptorName: string;
	initiatorId: number;
	initiatorName: string;
	initializeDate: string | null;
	signatureId: number;
	signatureDescription: string;
	signatureStateId: number;
	signatureStateDescription: string;
	reason: string;
	acceptDeclineReason: string;
	signatureDate: string | null;
	signatureResolutionName: string;
	isDynamic: boolean;
	isActive: boolean;
	possibleAcceptors: INamedEntityDto[];
	requestor: IUserShort;
	signatureStateRouteId: number | null;
	extParams: INtfTaskTemplateExtParam[];
	isAsyncAvailable: boolean;
	isQueued: boolean;
	pcIsServerSign: boolean;
}

export interface INamedEntityDto {
	id: number;
	name: string;
}

export interface ITaskFullSnapshot {
	taskSnapshotHash: string;
	currentTaskSnapshotHash: string;
	taskSnapshot: ITaskSnapshot;
	taskSnapshotHTML: string;
	enableFileHashSaving: boolean;
	filesHashes: IFileHashes[];
}

export interface ITaskSnapshot {
	sysParams: SystemParameters;
	extParams: INtfTaskTemplateExtParam[];
}

export interface SystemParameters {
	description: string;
	dueDate?: Date;
	owner: IUserShort;
	performers?: IUserShort[];
	subscribers: IUserShort[];
	startDate?: Date;
	stateId: number;
	stateDescription: string;
	subcatId: number;
	subcatDescription: string;
}

export interface IFileHashes {
	fileId: number;
	actualHash: string;
	savedHash: string;
	fileName: string;
	enableFileSaving: boolean;
	versionId?: number;
}

export interface IFileExistanceDto {
	fileName: string;
	isExistInTask: boolean;
}
